import type { HTMLAttributes } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import css from './skeleton.module.scss';

type SkeletonVariant = 'text' | 'circular' | 'rectangular';

type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  height?: string | number;
  variant?: SkeletonVariant;
  width?: string | number;
};

export const Skeleton = ({
  height,
  variant = 'text',
  width,
  className,
  style,
  ...restProps
}: SkeletonProps) => (
  <div
    className={joinCss(
      css.root,
      variant === 'circular' && css.circular,
      variant === 'rectangular' && css.rectangular,
      className
    )}
    style={{ height, width, ...style }}
    {...restProps}
  />
);
